import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { MouseBlockerProperties } from "@lib/titan2/dist/game/control/properties/MouseBlockerProperties";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { CommonStyle } from "@lib/titan2/dist/game/view/style/CommonStyle";
import { ArrayUtil } from "@lib/titan2/dist/util/collection/ArrayUtil";
import * as PIXI from "pixi.js";
import { SlingoLang } from "../lang/SlingoLang";
import { FontStyle } from "../style/FontStyle";
/**
 * AbstractAvailableWinDisplayProperties.ts
 */
export class AbstractAvailableWinDisplayProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.mouseBlockerProperties = new MouseBlockerProperties(0x000000, 0.6, false);
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.availableWinProperties?.equals(other?.availableWinProperties) &&
            this.availableWinTextHolderPosition.equals(other.availableWinTextHolderPosition) &&
            ArrayUtil.equals(this.availableWinTextHolderFilters, other.availableWinTextHolderFilters) &&
            this.availableWinLabelProperties.equals(other.availableWinLabelProperties) &&
            this.availableWinFieldProperties.equals(other.availableWinFieldProperties) &&
            this.availableWinTextHolderScale.equals(other.availableWinTextHolderScale) &&
            this.backgroundProperties.equals(other.backgroundProperties) &&
            this.mouseBlockerProperties.equals(other.mouseBlockerProperties);
    }
    setDefaultValues() {
        this.availableWinTextHolderPosition = new PIXI.Point(0, 0);
        this.availableWinTextHolderFilters = [];
        this.availableWinLabelProperties = new TextFieldProperties(FontStyle.DEFAULT, null, SlingoLang.AVAILABLE_WIN, ControlConstants.CENTER).setMultiline(true);
        this.availableWinFieldProperties = new TextFieldProperties(FontStyle.DEFAULT, null, null, ControlConstants.CENTER);
        this.availableWinTextHolderScale = new PIXI.Point(1, 1);
        this.backgroundProperties = new SpriteProperties(CommonStyle.MESSAGE_DIALOG_0, CommonStyle.MODULE, new PIXI.Point(0, 0), new PIXI.Point(1, 1), new PIXI.Point(0.5, 0.5));
    }
}
//# sourceMappingURL=AbstractAvailableWinDisplayProperties.js.map